import React, { useEffect } from 'react';

import { Table } from '../../../common/table/Table';

import './ClientsViewActivityLog.css';

export const ClientsViewActivityLog = ({ client, setActiveTab }) => {
  useEffect(() => {
    setActiveTab('clientsViewActivityLog');
  }, [setActiveTab]);

  const formatDate = (string) => {
    const [date, time] = string.split(' ');
    const [day, month, year] = date.split('.');

    return `${day}/${month}/${year} ${time}`;
  };

  const columnWidths = {
    timestamp: '10vw',
    user: '10vw',
    activity: '80vw',
  };

  return (
    <div className="client-view-activity-log-container">
      {client?.activityLogs && (
        <Table
          tableData={client.activityLogs.map((log) => ({
            timestamp: formatDate(log.timeStamp),
            user: log.user,
            activity: log.activity,
          }))}
          hiddenColumns={[]}
          columnWidths={columnWidths}
          maxRowCount={8}
          tableTitle="Activity Log"
          searchEnabled
          filterEnabled
        />
      )}
    </div>
  );
};
